import React from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import {
  CardNumberInput,
  CardExpiryInput,
  CardCVCInput,
} from '../../components/payments';

const CardFields = (props) => {
  const {
    cardType = '',
    cardNumber = '',
    cardExpMonth = '',
    cardExpYear = '',
    cardCVC = '',
    onChangeInput = () => {},
  } = props;

  const cardExpiry = !isEmpty(cardExpMonth) && !isEmpty(cardExpYear)
    ? `${cardExpMonth}/${cardExpYear.toString().substr(2, 2)}`
    : '';

  return (
    <React.Fragment>
      <div className="row"><div className="col-md-12"><br/></div></div>
      <div className="row">
        <div className="col-md-12 col-xs-12">
          <div className="card-number-wrapper">
            <div className="card-logos">
              <CardsImage src="../../images/svg/visa.svg" alt="image"/>
              <CardsImage src="../../images/svg/mastercard.svg" alt="image"/>
              <CardsImage src="../../images/svg/amex.svg" alt="image"/>
              <CardsImage src="../../images/svg/discover.svg" alt="image"/>
            </div>
            <CardNumberInput
              onChange={onChangeInput('cardNumber')}
              onCardChange={onChangeInput('cardType')}
              required
              className="border-radius-4"
              size="20"
              name="number"
              placeholder="0000 0000 0000 0000"
              style={styles.input}
              defaultValue={cardNumber}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <CardExpiryInput
            onChange={onChangeInput('expiry')}
            required
            className="border-radius-4"
            size="4"
            name="cvc"
            placeholder="MM/YY"
            style={styles.input}
            defaultValue={cardExpiry}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <CardCVCInput
            onChange={onChangeInput('cardCVC')}
            cardType={cardType}
            required
            className="border-radius-4"
            size="4"
            name="cvc"
            placeholder="CVC"
            style={styles.input}
            defaultValue={cardCVC}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

const CardsImage = styled.img`
  height: 26px;
`;

const styles = {
  input: {
    height: 46,
    fontSize: '1.5rem',
  },
};

export default CardFields;
